import React, { useEffect, useReducer } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import editReducer, { defaultState, setRenewDataCreator, updateFieldCreator } from './reducer';
import { createIpmaCisCreator } from '../../../../../store/actionsCreators';
import RenewCertificate from '../../../../../shared/Cis/Certificates/Renew/RenewCertificate';

function RenewIpmaCertificate({ certificate, renewCertificate, levelDomains }) {
  const [state, dispatch] = useReducer(editReducer, defaultState);

  useEffect(() => {
    if (certificate) {
      dispatch(setRenewDataCreator(certificate));
    }
  }, [certificate]);

  return (
    <RenewCertificate
      state={state}
      dispatch={dispatch}
      updateFieldCreator={updateFieldCreator}
      renewCertificate={renewCertificate}
      levelDomains={levelDomains}
      type="ipma"
    />
  );
}

RenewIpmaCertificate.propTypes = {
  certificate: PropTypes.shape({
    id: PropTypes.number,
    certificateHolder: PropTypes.number,
    levelDomain: PropTypes.number,
    certificationBody: PropTypes.number,
    issueDate: PropTypes.any,
    type: PropTypes.string,
    validUntil: PropTypes.any,
    certId: PropTypes.string,
    holderAuthorized: PropTypes.bool,
    visibility: PropTypes.bool,
    organization: PropTypes.number,
    memberAssociation: PropTypes.number,
  }),
  renewCertificate: PropTypes.func.isRequired,
};

RenewIpmaCertificate.defaultProps = {
  certificate: {},
};

const mapStateToProps = ({ ipma, globals }) => ({
  certificate: ipma.cis.certificates.profile,
  levelDomains: globals.cis.levelDomains,
});

const mapDispatchToProps = (dispatch) => ({
  renewCertificate: (payload, history) =>
    dispatch(createIpmaCisCreator('certificates', payload, history)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RenewIpmaCertificate);
